(() => {
  // Second card image: studio or lifestyle photos fill the tile; cut-outs and white-background shots stay inset.
  if (!window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;
  const canvas = document.createElement('canvas');
  canvas.width = canvas.height = 1;
  const ctx = canvas.getContext('2d', { willReadFrequently: true });
  const classify = (img) => {
    if (img.dataset.checked) return;
    img.dataset.checked = '1';
    const run = () => {
      try {
        ctx.clearRect(0, 0, 1, 1);
        ctx.drawImage(img, 2, 2, 1, 1, 0, 0, 1, 1);
        const [r, g, b, a] = ctx.getImageData(0, 0, 1, 1).data;
        if (a > 200 && (r + g + b) / 3 < 240) img.classList.add('is-photo');
      } catch (e) { /* cross-origin blocked: keep the inset look */ }
    };
    if (img.complete && img.naturalWidth) run(); else img.addEventListener('load', run, { once: true });
  };
  document.addEventListener('pointerover', (e) => {
    const card = e.target.closest && e.target.closest('.gp-card');
    const img = card && card.querySelector('.gp-card__alt');
    if (img) { img.loading = 'eager'; classify(img); }
  }, { passive: true });
})();
